/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Clear_Timecodes_TitleInputs */

const en_shortcut_keys_clear_timecodes_title = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure?`)
};

const fr_shortcut_keys_clear_timecodes_title = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etes-vous sur ?`)
};

const de_shortcut_keys_clear_timecodes_title = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bist du sicher?`)
};

const it_shortcut_keys_clear_timecodes_title = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei sicuro?`)
};

const ru_shortcut_keys_clear_timecodes_title = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уверены?`)
};

const es_shortcut_keys_clear_timecodes_title = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Está seguro?`)
};

const zh_cn2_shortcut_keys_clear_timecodes_title = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你确定吗？`)
};

const ja_shortcut_keys_clear_timecodes_title = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本気ですか？`)
};

const hi_shortcut_keys_clear_timecodes_title = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आपको यकीन है?`)
};

const pt_pt2_shortcut_keys_clear_timecodes_title = /** @type {(inputs: Shortcut_Keys_Clear_Timecodes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem certeza?`)
};

/**
* | output |
* | --- |
* | "Are you sure?" |
*
* @param {Shortcut_Keys_Clear_Timecodes_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_clear_timecodes_title = /** @type {((inputs?: Shortcut_Keys_Clear_Timecodes_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Clear_Timecodes_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_clear_timecodes_title(inputs)
	if (locale === "de") return de_shortcut_keys_clear_timecodes_title(inputs)
	if (locale === "it") return it_shortcut_keys_clear_timecodes_title(inputs)
	if (locale === "ru") return ru_shortcut_keys_clear_timecodes_title(inputs)
	if (locale === "es") return es_shortcut_keys_clear_timecodes_title(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_clear_timecodes_title(inputs)
	if (locale === "ja") return ja_shortcut_keys_clear_timecodes_title(inputs)
	if (locale === "hi") return hi_shortcut_keys_clear_timecodes_title(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_clear_timecodes_title(inputs)
	return en_shortcut_keys_clear_timecodes_title(inputs)
});